import { render, staticRenderFns } from "./TheSidebarMenuTeam.vue?vue&type=template&id=6b5caec2&scoped=true"
import script from "./TheSidebarMenuTeam.vue?vue&type=script&lang=js"
export * from "./TheSidebarMenuTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5caec2",
  null
  
)

export default component.exports